<template>
  <BTable
    :items="items"
    :fields="tableFields"
    empty-text="Tidak ada data yang ditampilkan."
    show-empty
    striped
    outlined
    class="table-head-capitalize"
  >
    <template #cell(no)="data">
      <span class="text-black">{{ data.index + 1 }}</span>
    </template>

    <!-- Template for CTWA table -->
    <template
      #cell(partner)="data"
    >
      <div class="flex items-center gap-3">
        <div>
          <span class="text-black">{{
            data.item.name || '-'
          }}</span>
          <div class="text-[#828282] text-sm">
            {{ data.item.email || '-' }}
          </div>
        </div>
      </div>
    </template>

    <template
      #cell(top_up_fee)="data"
    >
      <span>{{
        data.item.top_up_fee || 0
      }}%</span>
    </template>

    <template
      #cell(total_account)="data"
    >
      <span>{{
        data.item.total_account || 0
      }}</span>
    </template>

    <template
      #cell(total_spending)="data"
    >
      <span>{{
        IDR(data.item.total_spending)
      }}</span>
    </template>

    <template
      #cell(revenue)="data"
    >
      <span>{{
        IDR(data.item.revenue)
      }}</span>
    </template>
  </BTable>
</template>

<script>
import { IDR } from '@/libs/currency'
import { columnConfig } from './config'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableType: {
      type: String,
      default: 'whitelist',
      validator: value => ['whitelist'].includes(value),
    },
    platform: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      IDR,
    }
  },
  computed: {
    /**
     * Get table fields configuration based on table type
     * @returns {Array} Table fields configuration
     */
    tableFields() {
      if (this.platform !== 'meta') {
        return columnConfig.filter(item => item.key !== 'top_up_fee' && item.key !== 'revenue')
      }
      return columnConfig
    },
  },
}
</script>
<style scoped>
.b-table {
    border-radius: 20px !important;
}
</style>
